import { useRef } from "react";
import cookies from "js-cookie";
import { Header3, MainText, PrimaryButton, Link, Flex } from "@base-ui";
import { Dialog } from "./cookieWarning.styles.js";
import { closePopup } from "utils/events";
import { useLockedFocusArea } from "hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CookieWarning() {
  var containerRef = useRef();
  var firstRef = useRef();
  var lastRef = useRef();
  useLockedFocusArea(containerRef, firstRef, lastRef);
  var allow = function allow() {
    cookies.set("visAllowCookies", true, {
      expires: 365
    });
    closePopup();
  };
  var ingress = "V\xE5rden i siffror anv\xE4nder sig utav cookies samt Matomo f\xF6r att f\xF6rb\xE4ttra anv\xE4ndarupplevelsen p\xE5 sidan.\n    Genom att forts\xE4tta anv\xE4nda sidan accepterar du att V\xE5rden i siffror lagrar och anv\xE4nder information i cookies.";
  return /*#__PURE__*/_jsxs(Dialog, {
    ref: containerRef,
    children: [/*#__PURE__*/_jsx(Header3, {
      inverted: true,
      as: "h2",
      children: "Lagring av data"
    }), /*#__PURE__*/_jsx(MainText, {
      inverted: true,
      children: ingress
    }), /*#__PURE__*/_jsxs(Flex.Row, {
      justifyContent: "center",
      flexWrap: "wrap",
      mt: "20px",
      children: [/*#__PURE__*/_jsx(PrimaryButton, {
        ref: firstRef,
        onClick: allow,
        mr: "20px",
        width: "150px",
        children: "Ok"
      }), /*#__PURE__*/_jsx(Link, {
        inverted: "true",
        ref: lastRef,
        onClick: allow,
        to: "/faq?activetab=vanliga-fragor&open=vilken-information-lagrar-varden-i-siffror",
        width: "fit-content",
        children: "L\xE4s mer om cookies"
      })]
    })]
  });
}